import { Divider } from "@material-ui/core";
import { GroupBase, GroupProps, OptionsOrGroups, components } from "react-select5";

export function GroupComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: GroupProps<Option, IsMulti, Group> & {
    addNewLabel?: string;
    value?: string;
    mainOptions?: OptionsOrGroups<Option, Group>;
  }
) {
  const isGroup = (value: any): value is Group => {
    return "options" in value;
  };

  const optionHasValue = (option: Option, value?: string) => {
    return (
      option &&
      typeof option === "object" &&
      "value" in option &&
      String(option.value).toLowerCase() === value?.toLowerCase()
    );
  };

  const isNewSection = props.label === props.addNewLabel;

  const alreadyExists = props.mainOptions?.find((objectOrGroup: any) => {
    if (isGroup(objectOrGroup)) {
      return objectOrGroup.options.find((option) => optionHasValue(option, props.value));
    } else {
      return optionHasValue(objectOrGroup, props.value);
    }
  });

  if (isNewSection && alreadyExists) return;

  return (
    <>
      <components.Group {...props} />
      <Divider />
    </>
  );
}
